<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-name">{{formatString(videoType)}} Video List
                <!--<button type="submit" v-on:click.prevent="addCategory" class="btn btn-primary waves-effect pull-right">Add</button>-->
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <!-- List Content Here -->
                <!-- List Content Here -->
                <vue-good-table
                        ref="VideoList"
                        mode="remote"
                        title="Category List"
                        @on-page-change="onPageChange"
                        @on-selected-rows-change="selectionChanged"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                    enabled: true,
                    mode: 'pages',
                    pageLabel: 'Page',
                    position: 'bottom',
                    perPage: serverParams.perPage,
                    perPageDropdown: [25, 50, 100, 200 ,500],
                    dropdownAllowAll: false,
                    }"
                        :selectOptions="{
                    enabled: true,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    }"

                        :search-options="{
                    enabled: false,
                    }">

                    <div slot="selected-row-actions" slot-scope="computed">
                        {{computed.selectedRows}}
                        <!--<button id="deleteMultiple" class="btn btn-primary" v-on:click.prevent="deleteVideo()">Delete Video ({{selectedRows}})</button>-->
                    </div>


                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <!--class="btn btn-xs btn-primary"-->
                            <div v-if="props.column.field == 'action'" class="table-action">
                                <router-link title='Edit Video' class="btn btn-primary" v-bind:to="{name: 'UpdateVideo',params:{type:videoType,id:props.row.id}}"><i class="fa fa-pencil" aria-hidden="true"></i></router-link>
                                <!--<button title='Delete Video' id="delete" class="btn btn-primary"  v-on:click.prevent="deleteVideo(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>-->
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                </vue-good-table>
            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- /#page-content-wrapper -->
</template>

<script>
    import Vue from 'vue';
    import BackendFooter from '@/components/backend/partials/Footer';
    import SessioMixin from '../../../mixins/sessionmixin';
    import { HTTP } from '../../../http-common';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);

    var self;
    export default {
        name: 'ListCategories',
        mixins: [SessioMixin],
        components: {
            'app-backend-footer': BackendFooter,
        },
        data() {
            return {
                videoType: '',
                firstLoad: 0,
                columns: [
                    /*{
                     label: 'ID',
                     field: 'id',
                     filterable: true,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "ID", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     filterDropdownItems: [], // dropdown (with selected values) instead of text input
                     filterFn: this.onColumnFilter, //custom filter function that
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Title',
                        field: 'video_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Title", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'State',
                        field: 'location',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "State", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Role',
                        field: 'role',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Role", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                        label: 'Video Path',
                        field: 'video_path',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Video Path", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },*/
                    {
                        label: 'Status',
                        field: 'status',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Status", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: ['Active', 'Inactive'], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Updated By',
                        field: 'updated_by',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Updated By", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: 'id',
                        type: 'asc',
                    },
                },
                recordsCounts: "",
                selectedRows: 0,
            }
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
            //self.checkLogin();
        },
        mounted: function () {
//            self = this;
            self.videoType = this.$route.params.type;
            self.loadLocationsAdd();
        },
        watch: {
            '$route'(to, from) {
                self.videoType = this.$route.params.type;
                self.loadVideo();
            }
        },
        methods: {
            loadLocationsAdd(loading, search, vm) {
                var data = {
                    search: search
                };
                HTTP.post("getlocation", data)
                    .then(function (response) {
                        self.locationArr = [];
                        // self.locationArr = response.data.content;
                        $.each(response.data.content, function (i) {
                            self.locationArr.push(response.data.content[i].text);
                        });
                        /*$.each(response.data.content, function (i) {
                         if (response.data.content[i].value == 0) {
                         self.locationArr.push(response.data.content[i]);
                         }
                         });
                         $.each(response.data.content, function (i) {
                         if (response.data.content[i].value != 0) {
                         self.locationArr.push(response.data.content[i]);
                         }
                         });*/
                        $.each(self.columns, function (i) {
                            if (self.columns[i].field == 'location') {
                                self.columns[i].filterOptions.filterDropdownItems = self.locationArr;
                            }
                        });
                        if (typeof (loading) != "undefined") {loading(false);}
                    })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                self.$router.push("/login");
                                //EventBus.$emit("logged-in", true, "", "");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            },
            addCategory() {
                self.$router.push('/backend/addvideo/' + self.videoType);
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({page: params.currentPage});
                self.loadVideo();
            },
            //
            onPerPageChange(params) {
                self.updateParams({perPage: params.currentPerPage});
                self.totalRecords = self.totalRecords;
                self.loadVideo();
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: ('video_name');
                    field: ('location');
                    field: ('role');
                    field: ('video_path');
                    field: ('status');
                    field: ('updated_by');
                    field: ('action');
                }
                ;
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (self.firstLoad == 1 || filters.location || filters.role || filters.video_path|| filters.status|| filters.updated_by || filters.action) {
                    self.loadVideo();
                }

            },
            selectionChanged() {
                self.selectedRows = (self.$refs['VideoList'].selectedRows).length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                self.loadVideo();
            },

            deleteVideo: function (id) {
                var userArr = [];
                if (id) {
                    userArr.push(id);
                } else {
                    var selectedUser = self.$refs['VideoList'].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        userArr.push(self.$refs['VideoList'].selectedRows[i].id);
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    data: {
                        type: self.videoType,
                        deleteArr: userArr,
                    }
                };
                this.$swal({
                    title: 'Are you sure?',
                    text: 'You can\'t revert your action',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes Delete it!',
                    cancelButtonText: 'No, Keep it!',
                    showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        HTTP.delete("deletevideo", config)
                            .then(function (response) {
                                console.log("in response");
                                self.loadVideo();
                            })
                            .catch(function (err) {
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem("user_obj");
                                        localStorage.removeItem("api_token");
                                        localStorage.removeItem("profile_image");
                                        self.$router.push("/login");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                }
                            });
                        self.$swal('Deleted', 'You successfully deleted video(s)', 'success')
                    } else {
                        self.$swal('Cancelled', 'Your file is still intact', 'info')
                    }
                })
            },

            loadVideo: function () {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage)
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                var fields = {
                    type: this.$route.params.type,
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort
                };
                HTTP.post('listvideo', fields, config).then(function (response) {
                    if (response.data.code == '200') {
                        self.rows = response.data.content.row;
                        self.totalRecords = response.data.content.totalRecords;

                    }

                })
                    .catch(function (err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    })
            },
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/backend/videomaster/ListVideo.vue